import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18174306"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormFieldComboBox = _resolveComponent("FormFieldComboBox")!
  const _component_BaseTable = _resolveComponent("BaseTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BaseTable, {
        "column-defs": _ctx.columnDefs,
        "row-data": _ctx.products,
        loading: false,
        enumerable: true
      }, {
        "cell(option-0)": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.options[0].name), 1)
        ]),
        "cell(option-1)": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.options[1].name), 1)
        ]),
        "cell(option-2)": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.options[2].name), 1)
        ]),
        "cell(products)": _withCtx(({ row }) => [
          _createVNode(_component_FormFieldComboBox, {
            value: row.product,
            "onUpdate:value": ($event: any) => ((row.product) = $event),
            clearable: true,
            filterable: false,
            options: _ctx.productSearchListOption,
            loading: _ctx.isProductLoading,
            "no-options-message": _ctx.noProductOptionsMessage,
            "onChange:query": _ctx.handleProductSearchQueryChange
          }, null, 8, ["value", "onUpdate:value", "options", "loading", "no-options-message", "onChange:query"])
        ]),
        _: 1
      }, 8, ["column-defs", "row-data"])
    ])
  ]))
}